module.exports = __webpack_public_path__ + "img/sieckFinesseSetup3.84c74fec.png";